import ActionTypes from './ActionTypes';
import Dispatcher from './Dispatcher';

export default {
  find(categoryId, themeId) {
    Dispatcher.dispatch({
      actionType: ActionTypes.TIMELESS_THEME_STORE_FIND,
      categoryId,
      themeId,
    });
  },

  complete(categoryId, themeId) {
    Dispatcher.dispatch({
      actionType: ActionTypes.TIMELESS_THEME_STORE_MARK_AS_COMPLETED,
      categoryId,
      themeId,
    });
  },
}
